module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("自动生成二维码")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addTemplate1
    }
  }, [_vm._v("绑定链接")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addTemplate3
    }
  }, [_vm._v("导出选择")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请选择批次",
      "remote": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleLinkChange4
    },
    model: {
      value: (_vm.batch_notes),
      callback: function($$v) {
        _vm.batch_notes = $$v
      },
      expression: "batch_notes"
    }
  }, _vm._l((_vm.groupList), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.batch_notes,
        "value": item.batch_notes
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.exploadCode
    }
  }, [_vm._v("二维码下载")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 100
    }
  }, [_c('el-col', {
    staticClass: "grid-content bg-purple",
    staticStyle: {
      "margin": "0 2rem"
    },
    attrs: {
      "span": 100,
      "type": "info"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "orange",
      "margin-top": "1rem"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("警告：访问此页面请使用http协议。或"), _c('el-link', {
    staticStyle: {
      "margin-left": "1rem",
      "font-weight": "800"
    },
    attrs: {
      "href": "http://b.yaoking.cn/publicity/publicity_qrcodes",
      "type": "success"
    }
  }, [_vm._v("点击此处")])], 1), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-bottom": "1rem"
    },
    attrs: {
      "type": "info"
    }
  }, [_vm._v("注：宣传码生成规则为：https://r.yaoking.cn/?codes=标识符（例如：https://r.yaoking.cn/?codes=100000000001）")])])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.data,
      "height": _vm.wheight - 130
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [(_vm.batch_notes == '') ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "codes",
      "label": "标识符",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "link_title",
      "label": "链接标题",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_id",
      "label": "员工id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activation",
      "label": "激活状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.activation == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("已激活")]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("未激活")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator_id",
      "label": "操作员ID",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator_name",
      "label": "操作员姓名",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activated_at",
      "label": "激活时间",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.activated_at, 'yyyy-MM-dd hh:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "counts",
      "label": "扫码次数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "数据生成时间",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.created_at, 'yyyy-MM-dd hh:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_at",
      "label": "数据更新时间",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.updated_at, 'yyyy-MM-dd hh:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_at",
      "label": "查看二维码",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-link', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.exploadCodeOne(scope.row)
            }
          }
        }, [_vm._v("查看二维码")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1),
      expression: "loading1"
    }],
    attrs: {
      "title": "选择生成数量",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "生成数量:",
        "prop": "content_type",
        "rules": [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }]
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.form.num),
        callback: function($$v) {
          _vm.$set(_vm.form, "num", $$v)
        },
        expression: "form.num"
      }
    }, _vm._l((_vm.nums), function(item, index) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.name,
          "value": item.value
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "批次备注:",
        "prop": "content_type",
        "rules": [{
          required: true,
          message: '必填项',
          trigger: 'blur'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "批次备注",
        "size": "small"
      },
      model: {
        value: (_vm.form.remarks),
        callback: function($$v) {
          _vm.$set(_vm.form, "remarks", $$v)
        },
        expression: "form.remarks"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "随机标识符"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.randflag),
        callback: function($$v) {
          _vm.$set(_vm.form, "randflag", $$v)
        },
        expression: "form.randflag"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1",
        "border": ""
      }
    }, [_vm._v("随机标识符（一次性适用）")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "0",
        "border": ""
      }
    }, [_vm._v("顺序标识符")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveData
      }
    }, [_vm._v("确定生成")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑/修改(单行)",
      "width": "30%",
      "visible": _vm.memberTagDialog2,
      "before-close": _vm.handleCancelLabelsDialog2
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog2 = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.saveForm,
        "label-width": "230px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "修改前链接",
        "prop": "content_type",
        "rules": [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }]
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.saveForm.link_title))])]), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "绑定链接",
        "prop": "content_type",
        "rules": [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }]
      }
    }, [_c('el-select', {
      attrs: {
        "size": "small",
        "filterable": "",
        "placeholder": "请选择连接",
        "remote": "",
        "remote-method": _vm.getLinkList
      },
      on: {
        "change": _vm.handleLinkChange1
      },
      model: {
        value: (_vm.saveForm.link_id),
        callback: function($$v) {
          _vm.$set(_vm.saveForm, "link_id", $$v)
        },
        expression: "saveForm.link_id"
      }
    }, _vm._l((_vm.linksList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.content,
          "value": item.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveRow
      }
    }, [_vm._v("确定修改")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出选择",
      "width": "30%",
      "visible": _vm.memberTagDialog3,
      "before-close": _vm.handleCancelLabelsDialog3
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog3 = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.exp,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "方式选择"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.exp.mode_type),
        callback: function($$v) {
          _vm.$set(_vm.exp, "mode_type", $$v)
        },
        expression: "exp.mode_type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1",
        "border": ""
      }
    }, [_vm._v("标识符区间")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "3",
        "border": ""
      }
    }, [_vm._v("标题")])], 1)], 1), _vm._v(" "), (_vm.exp.mode_type == 1) ? _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "区间:"
      }
    }, [_c('el-input', {
      staticClass: "num_b",
      attrs: {
        "type": "text",
        "placeholder": "起始",
        "size": "small"
      },
      model: {
        value: (_vm.exp.start),
        callback: function($$v) {
          _vm.$set(_vm.exp, "start", $$v)
        },
        expression: "exp.start"
      }
    }), _vm._v("-\n        "), _c('el-input', {
      staticClass: "num_b",
      attrs: {
        "type": "text",
        "placeholder": "结束",
        "size": "small"
      },
      model: {
        value: (_vm.exp.end),
        callback: function($$v) {
          _vm.$set(_vm.exp, "end", $$v)
        },
        expression: "exp.end"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.exp.mode_type == 3) ? _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "绑定链接",
        "prop": "content_type",
        "rules": [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }]
      }
    }, [_c('el-select', {
      attrs: {
        "size": "small",
        "filterable": "",
        "placeholder": "请选择连接",
        "remote": "",
        "remote-method": _vm.getLinkList
      },
      on: {
        "change": _vm.handleLinkChange3
      },
      model: {
        value: (_vm.exp.link_id),
        callback: function($$v) {
          _vm.$set(_vm.exp, "link_id", $$v)
        },
        expression: "exp.link_id"
      }
    }, _vm._l((_vm.linksList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.content,
          "value": item.id
        }
      })
    }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.expData
      }
    }, [_vm._v("确定导出")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "同步七牛云",
      "width": "30%",
      "visible": _vm.memberTagDialog4,
      "before-close": _vm.handleCancelLabelsDialog4
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog4 = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.SynchroRow,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "绑定链接",
        "prop": "content_type",
        "rules": [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }]
      }
    }, [_c('el-select', {
      attrs: {
        "size": "small",
        "filterable": "",
        "placeholder": "请选择批次",
        "remote": ""
      },
      on: {
        "change": _vm.handleLinkChange4
      },
      model: {
        value: (_vm.SynchroRow.batch_notes),
        callback: function($$v) {
          _vm.$set(_vm.SynchroRow, "batch_notes", $$v)
        },
        expression: "SynchroRow.batch_notes"
      }
    }, _vm._l((_vm.groupList), function(item) {
      return _c('el-option', {
        key: item.key,
        attrs: {
          "label": item.batch_notes,
          "value": item.batch_notes
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.Synchro
      }
    }, [_vm._v("确定")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "绑定二维码",
      "width": "40%",
      "visible": _vm.memberTagDialog1,
      "before-close": _vm.handleCancelLabelsDialog1
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog1 = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.bang,
        "label-width": "230px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "绑定数量:"
      }
    }, [_c('el-input', {
      staticClass: "num_b",
      attrs: {
        "type": "text",
        "placeholder": "绑定数量",
        "size": "small"
      },
      model: {
        value: (_vm.bang.num_b),
        callback: function($$v) {
          _vm.$set(_vm.bang, "num_b", $$v)
        },
        expression: "bang.num_b"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "绑定类型"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      on: {
        "change": _vm.changeContentType
      },
      model: {
        value: (_vm.content_type),
        callback: function($$v) {
          _vm.content_type = $$v
        },
        expression: "content_type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "商品",
        "border": ""
      }
    }, [_vm._v("商品")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "专题",
        "border": ""
      }
    }, [_vm._v("专题")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "品牌",
        "border": ""
      }
    }, [_vm._v("品牌")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "充余额",
        "border": ""
      }
    }, [_vm._v("充余额")])], 1)], 1), _vm._v(" "), (_vm.content_type == '商品') ? _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "是否小程序"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.is_wxapp),
        callback: function($$v) {
          _vm.is_wxapp = $$v
        },
        expression: "is_wxapp"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1",
        "border": ""
      }
    }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "0",
        "border": ""
      }
    }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.content_type == '商品') ? _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "选择商品"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "55%"
      },
      attrs: {
        "filterable": "",
        "placeholder": "请输入商品货号",
        "remote": "",
        "remote-method": _vm.getItemShopsList
      },
      on: {
        "change": _vm.handleItemShopsChange
      },
      model: {
        value: (_vm.relItemsShops),
        callback: function($$v) {
          _vm.relItemsShops = $$v
        },
        expression: "relItemsShops"
      }
    }, _vm._l((_vm.relItemsShopsList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-col', [_c('el-input', {
      model: {
        value: (_vm.relItemsShopsVal),
        callback: function($$v) {
          _vm.relItemsShopsVal = $$v
        },
        expression: "relItemsShopsVal"
      }
    })], 1)], 1)], 1) : _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "绑定链接"
      }
    }, [_c('el-select', {
      attrs: {
        "size": "small",
        "filterable": "",
        "placeholder": "请选择连接",
        "remote": "",
        "remote-method": _vm.getLinkList
      },
      on: {
        "change": _vm.handleLinkChange
      },
      model: {
        value: (_vm.bang.link_id),
        callback: function($$v) {
          _vm.$set(_vm.bang, "link_id", $$v)
        },
        expression: "bang.link_id"
      }
    }, _vm._l((_vm.linksList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.content,
          "value": item.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.upData
      }
    }, [_vm._v("确定绑定")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5cd8ef3e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cd8ef3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/publicity/publicity_qrcodes.vue
// module id = 2750
// module chunks = 0